export class BoipaLandingDto {
    /** The total transaction amount, including tax, shipping, surcharge and discount amounts. */
    amount?: string;
    /** Transaction id in the BOIPA Gateway. */
    txId?: string;
    /** Transaction identifier or Order ID in merchant system. */
    merchantTxId?: string;
    /** String (enum): `success` | `failure` | `redirection`. */
    result?: string;
    /** Currency alphabetic code as defined in the ISO 4217 standard */
    currency: string
}


// sample success
// {
//     merchantTxId: '294',
//     txId: '11895013',
//     currency: 'EUR',
//     amount: '6',
//     result: 'success'
//   }
  

// sample declined

// {"data": {"txId": "11895023", "amount": "6", "result": "failure", "currency": "EUR", "merchantTxId": "296"}}